import { DefaultDisplayValue } from 'app/enums';
import { TournamentEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';

interface UseTournamentSettingsProps {
  teamsSize: string;
}

export const useTournamentSettings = (tournament: TournamentEntity): UseTournamentSettingsProps => {
  const teamsSize = useMemo(() => {
    if (!tournament) {
      return DefaultDisplayValue.DASH;
    }

    const maxTeams = tournament.teamsSettings?.maxTeams ?? 0;
    const minTeams = tournament.teamsSettings?.minTeams ?? 0;

    return `${minTeams}-${maxTeams}`;
  }, [tournament]);

  return { teamsSize };
};
